import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { addIcons } from 'ionicons';
import * as icons from 'ionicons/icons';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

addIcons(icons);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => {
    console.log(err)
    console.log(err.stack)
  });
